import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import { useDownloadJobApplicationMutation } from 'services/organizationsV2';

export const useDownloadApplicants = () => {
  const currentNetwork = useSelector(activeNetworkSelector);
  const [download, { isLoading }] = useDownloadJobApplicationMutation();

  const downloadApplicants = useCallback(async () => {
    await download(currentNetwork.id);
    toast('Export in progress — we’ll email it to you in a few minutes.', {
      icon: 'success',
      id: 'download_job_application',
    });
  }, [download, currentNetwork.id]);

  return {
    downloadApplicants,
    loading: isLoading,
  };
};
